import * as React from 'react';
import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { StarRating } from '@liveauctioneers/hammer-ui-core/starRating';
import styled from 'styled-components';

type Props = {
    rating: number;
};

const RatingDisplay = (props: Props) => {
    const { rating } = props;
    return rating >= 0 ? (
        <RatingContainer data-testid="symbolRatings">
            <StarRating
                averageRating={rating}
                emphasis="bold"
            />
            {rating > 0 && rating <= 5 && (
                <BodySecondary color="secondary">
                    <FormattedMessage id={`review_page.review_copy._${rating}`} />
                </BodySecondary>
            )}
        </RatingContainer>
    ) : (
        <div>
            <BodySecondary color="secondary">N/A</BodySecondary>
        </div>
    );
};

export default React.memo<Props>(RatingDisplay);

const RatingContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-top: 16px;

    & > div {
        margin-right: 16px;
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidth}) {
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        margin-top: 0;

        & > span {
            margin-top: 8px;
        }
    }
`;
